export const getStore = state => state.monitoredDocumentVersion || {};

export const getMonitoredDocumentVersion = state => getStore(state).monitoredDocumentVersion || {};

export const isFetching = state => getStore(state).fetching;
export const isFetched = state => getStore(state).fetched;
export const hasFailed = state => getStore(state).failed;
